import { View } from 'backbone.marionette';
import template from './index.jst';

export default class WidgetsSidebar extends View {

	get template() {
		return template;
	}

	get className() {
		return 'widgets-sidebar';
	}

	regions() {
		return {
			ads_container: '.ads-container',
			news_block:    '.news-block'
		};
	}

}